<template>
    <HelpIcon
        v-tooltip="info"
        class="h-5 w-5 cursor-pointer focus:outline-none"
        :class="[whiteMode ? 'text-white' : 'text-gray-400']"
    />
</template>
<script>
import { HelpIcon } from "@easy/ui/icons";

export default {
    name: "cInfo",
    props: {
        info: String,
        whiteMode: Boolean,
    },
    components: {
        HelpIcon,
    },
};
</script>
